import React from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {PaperProps, withStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../utils/ThemeUtils';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

export interface CategoryContentButtonProps extends PaperProps {
    title: string;
}

const CategoryContentButton = withStyles<string, undefined, CategoryContentButtonProps>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: 0,

        height: theme.spacing(8),
        padding: theme.spacing(0, 2),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.action.selected,

        '&> span': {
            fontSize: '14px',
            margin: theme.spacing(0, 1, 0, 3)
        },
        // Go back to categories icon
        '& svg:first-of-type': {
            fontSize: '1.2rem',
            transform: getDirectionStyles(theme.direction)('none', 'rotate(180deg)')
        }
    }
}))(({title, ...props}: CategoryContentButtonProps) => (
    <Paper aria-label="button" tabIndex={0} {...props}>
        <ChevronLeft />
        <Typography variant="body1" component="span">
            {title}
        </Typography>
    </Paper>
));

export default CategoryContentButton;
